const React = require("react");
const { countryName, selectedOption } = require("../../cjShippingDestinations");
const h = React.createElement;

const money = (value) => `$${(Number(value) || 0).toFixed(2)}`;

// Side-by-side comparison of the selected countries (one column each).
// Scrolls horizontally on narrow screens -- no data is ever hidden; the
// per-country cards below repeat everything in a stacked layout.
const CJShippingComparison = ({ countries, perCountry, computed, t }) => {
  const cell = (code, render) => {
    const state = perCountry[code];
    if (!state || state.status === "idle") return "-";
    if (state.status === "waiting") return t("h_cjms_status_waiting", "Waiting...");
    if (state.status === "loading") return t("h_cjms_status_loading", "Calculating...");
    if (state.status === "error") return t("h_cjms_status_error", "Error");
    const option = selectedOption(state);
    if (!option) return t("h_cjms_no_method_short", "No method");
    return render(option, state, computed[code] || {});
  };
  const rows = [
    [t("h_cjms_row_shipping", "Shipping"), (o) => money(o.price)],
    [t("h_cjms_row_delivery", "Delivery"), (o) => (o.deliveryDays ? `${o.deliveryDays} ${t("h_cj_days", "days")}` : "-")],
    [t("h_cjms_row_method", "Method"), (o) => o.carrier],
    [t("h_cjms_row_price", "Selling price"), (_o, _s, c) => (c.effectiveSellingPrice > 0 ? money(c.effectiveSellingPrice) : "-")],
    [t("h_cjms_row_profit", "Profit"), (_o, _s, c) => (c.pricing
      ? h("span", { className: c.pricing.profit >= 0 ? "cjms-num--ok" : "cjms-num--loss" }, money(c.pricing.profit))
      : "-")],
    [t("h_cjms_row_active", "Sold"), (_o, s) => (s.sellActive !== false ? t("h_cjms_yes", "Yes") : t("h_cjms_no", "No"))],
  ];
  return h("div", { className: "cjms-compare-wrap" },
    h("table", { className: "cjds-table cjms-compare" },
      h("thead", null, h("tr", null,
        h("th", { scope: "col" }, ""),
        ...countries.map((code) => h("th", { key: code, scope: "col" }, `${countryName(code)} (${code})`))
      )),
      h("tbody", null, ...rows.map(([label, render], index) => h("tr", { key: index },
        h("th", { scope: "row" }, label),
        ...countries.map((code) => h("td", { key: code, className: perCountry[code]?.stale ? "cjms-cell--stale" : "" }, cell(code, render)))
      )))
    )
  );
};

module.exports = { CJShippingComparison };
